module.exports = __webpack_public_path__ + "img/icon-email.a82b32c7.svg";